import { Formatter } from '@insightlabs/number-formatter';
import dateFnsFormat from 'date-fns/format';
const format = new Formatter();

export const toCurrency = (value, decimals = 2) => format.asMoney(value, decimals);

export const asDate = value => {
  if (typeof value === 'string') {
    return format.asDate(new Date(value));
  }
  return format.asDate(value);
};

export function formatValue(value, formatSettings, useAbbreviation = false, nullValue = "N/A") {

  if (value != null) {
      if (formatSettings) {
          try {
              let returnValue = value;
              if (formatSettings.type === 'fixed') {
                  if (useAbbreviation && formatSettings.abbreviation) {
                      returnValue = abbreviateNumber(value.toFixed(formatSettings.decimals));
                  } else {
                      returnValue = format.asFixed(value, formatSettings.decimals, formatSettings.useSeparator);
                  }
              } else if (formatSettings.type === 'money') {
                  if (useAbbreviation && formatSettings.abbreviation) {
                      returnValue = `$${abbreviateNumber(value.toFixed(formatSettings.decimals))}`;
                  } else {
                      returnValue = format.asMoney(value, formatSettings.decimals, value);
                  }
              } else if (formatSettings.type === 'date') {
                // console.log(value)
                  const toParse = typeof value === 'string' ? new Date(value) : value;
                  returnValue = dateFnsFormat(toParse, 'MM/dd/yyyy');
                //   console.log(returnValue)
              } else if (formatSettings.type ==='datetime') {
                const toParse = typeof value === 'string' ? new Date(value) : value;
                returnValue = dateFnsFormat(toParse, 'MM/dd/yyyy, h:mm a');
              } else if (formatSettings.type === 'percent') {
                  returnValue = format.asPct(value, formatSettings.decimals, value);
              }
              return returnValue + (formatSettings.unitPrefix ? formatSettings.unitPrefix : "");
          } catch (error) {
              console.log(error);
              return value.toString();
          }
      }
      return value.toString();
  } else {
      return nullValue.toString();
  }
};

const postfixes = ["", "K", "M", "B", "T"];

function abbreviateNumber(num) {
  let n = num || 0;
  const sign = n >= 0 ? "" : "-";
  let postCt = 0;
  n = Math.abs(n);
  while(n >= 1000) {
      if (postCt > 0 || n < 10000) { // Show 1 decimal place for under 10K, or when M or T
          n = (n/1000).toFixed(1);
      } else {
          n = Math.floor(n / 1000);
      }
      ++postCt;
  }
  const postfix = postfixes[postCt];
  return `${sign}${n}${postfix}`;
}

export function truncateString(str, n, useWordBoundary) {
  if (str.length <= n) { return str; }
  var subString = str.substr(0, n-1);
  return (useWordBoundary
     ? subString.substr(0, subString.lastIndexOf(' '))
     : subString) + "&hellip;";
};

export function addCommaSeparatorToNumber(value) {
  return formatValue(value, { type: 'fixed' }, false, 0);
}
